import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { isNewRelicEnabled, newRelicBrowserOptions } from './newRelicConfig';

let initialized = false;

function initNewRelicBrowserAgent(): void {
  if (initialized || typeof window === 'undefined') return;
  if (!isNewRelicEnabled()) return;
  try {
    new BrowserAgent(newRelicBrowserOptions);
    initialized = true;
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[New Relic] Browser agent failed to initialize', err);
    }
  }
}

initNewRelicBrowserAgent();
